"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var types_1 = require("./types");
function valid(state) {
    var isvalid = selection(state) && state.selected !== '';
    return isvalid ? isvalid : false;
}
exports.valid = valid;
function list(state) {
    if (!state.list)
        return [];
    var filteredList = state.list.filter(function (insurance) { return insurance.package !== types_1.travelInsuranceType; });
    return __spreadArrays([
        { price: 0, package: 'NONE', combination: 'NONE', code: 'NONE' }
    ], filteredList);
}
exports.list = list;
// returns the price of the selected insurance
function totalPrice(state) {
    var selected = state.list.find(function (insurance) { return insurance.code === state.selected; });
    return selected ? selected.price : 0;
}
exports.totalPrice = totalPrice;
// return the current price differ
function priceDiffer(state) {
    var priceDifferItem = lodash_1.find(state.priceDiffer, function (item) {
        return state.selected === item.code;
    });
    return priceDifferItem ? priceDifferItem.price : null;
}
exports.priceDiffer = priceDiffer;
// return the current price differ
function currentPriceDiffer(state) {
    var priceDifferItem = lodash_1.find(state.priceDiffer, function (item) {
        return state.selected === item.code;
    });
    return priceDifferItem ? priceDifferItem : null;
}
exports.currentPriceDiffer = currentPriceDiffer;
// returns the selected insurance data
function selection(state) {
    return state.selected;
}
exports.selection = selection;
// which request has fired last?
function lastFetchRequestKey(state) {
    return state.loading;
}
exports.lastFetchRequestKey = lastFetchRequestKey;
function channel(state) {
    return state.channel;
}
exports.channel = channel;
function fullInsurance(_state) {
    return types_1.fullInsuranceType;
}
exports.fullInsurance = fullInsurance;
function partInsurance(_state) {
    return types_1.partInsuranceType;
}
exports.partInsurance = partInsurance;
function combiFamily(_state) {
    return types_1.familyCombination;
}
exports.combiFamily = combiFamily;
function combiCouple(_state) {
    return types_1.coupleCombination;
}
exports.combiCouple = combiCouple;
function combiStandard(_state) {
    return types_1.standardCombination;
}
exports.combiStandard = combiStandard;
// returns the selected insurance type
function selectionType(state) {
    var selected = state.list.find(function (insurance) { return insurance.code === state.selected; });
    return selected ? selected.package : 'NONE';
}
exports.selectionType = selectionType;
// returns the selected insurance combination
function selectionCombination(state) {
    var selected = state.list.find(function (insurance) { return insurance.code === state.selected; });
    return selected ? selected.combination : 'NONE';
}
exports.selectionCombination = selectionCombination;
// returns the selected insurance combination for 'RRS'
function combinationForPartInsurance(state) {
    var selected = state.list.find(function (insurance) { return insurance.package === 'RRS'; });
    return selected ? selected.combination : 'NONE';
}
exports.combinationForPartInsurance = combinationForPartInsurance;
// returns the selected insurance combination for 'KS'
function combinationForFullInsurance(state) {
    var selected = state.list.find(function (insurance) { return insurance.package === 'KS'; });
    return selected ? selected.combination : 'NONE';
}
exports.combinationForFullInsurance = combinationForFullInsurance;
// export everything compliant to the vuex specification for getters
exports.default = {
    list: list,
    selection: selection,
    priceDiffer: priceDiffer,
    totalPrice: totalPrice,
    valid: valid,
    lastFetchRequestKey: lastFetchRequestKey,
    currentPriceDiffer: currentPriceDiffer,
    channel: channel,
    fullInsurance: fullInsurance,
    partInsurance: partInsurance,
    selectionType: selectionType,
    combiFamily: combiFamily,
    combiCouple: combiCouple,
    combiStandard: combiStandard,
    selectionCombination: selectionCombination,
    combinationForFullInsurance: combinationForFullInsurance,
    combinationForPartInsurance: combinationForPartInsurance
};
//# sourceMappingURL=getters.js.map